import React from "react";
import loadable from "@loadable/component";
import pMinDelay from 'p-min-delay'

import HeadData from "../data/HeadData";
import Header from "../components/sections/Header";
import HomeHeroUpdate from "../components/hero/HomeHeroUpdate";
import HomeHeroMobile from "../components/hero/HomeHeroMobile";
import ProductGalleryUpdateArauco from "../components/home/ProductGalleryUpdateArauco";
import PreviewAboutNew from "../components/home/PreviewAboutNew";
import ProductFeatureUpdateArauco from "../components/home/ProductFeatureUpdateArauco";
import ValuedSuppliers from "../components/controls/Prismic/ValuedSuppliers";
import Advantages from "../components/home/Advantages";
import ContactExpert from "../components/controls/ContactExpert";
import Hiring from "../components/home/Hiring";
import SatisfiedCustomerPlaceholder from "../components/controls/SatisfiedCustomerPlaceholder";
import Layout from "../components/layout/Layout";

const SatisfiedCustomerUpdate = loadable(() =>
  pMinDelay(import("../components/controls/SatisfiedCustomerUpdate"), 3000),{
    fallback:
    <SatisfiedCustomerPlaceholder />
  }
);

const IndexPage = () => {

  return (
    <Layout>
      <div className="w-full max-w-full relative overflow-hidden">
        <HeadData isHome />

        <Header isHome />

        <HomeHeroUpdate />

        <HomeHeroMobile />

        <ProductGalleryUpdateArauco />

        <PreviewAboutNew />

        <ProductFeatureUpdateArauco />

        <ValuedSuppliers />

        <Advantages />

        <ContactExpert />

        <SatisfiedCustomerUpdate />


        <Hiring />
      </div>
    </Layout>
  );
};

export default IndexPage;
